var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05464 10.3596H5.69466C4.76466 10.3596 4.01465 9.60963 4.01465 8.67963V5.31965C4.01465 4.38965 4.76466 3.63965 5.69466 3.63965H9.05464C9.98464 3.63965 10.7346 4.38965 10.7346 5.31965V8.67963C10.7346 9.60963 9.98464 10.3596 9.05464 10.3596Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0546 10.3596H15.6946C14.7646 10.3596 14.0146 9.60963 14.0146 8.67963V5.31965C14.0146 4.38965 14.7646 3.63965 15.6946 3.63965H19.0546C19.9846 3.63965 20.7346 4.38965 20.7346 5.31965V8.67963C20.7346 9.60963 19.9846 10.3596 19.0546 10.3596Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05464 20.3596H5.69466C4.76466 20.3596 4.01465 19.6096 4.01465 18.6796V15.3196C4.01465 14.3896 4.76466 13.6396 5.69466 13.6396H9.05464C9.98464 13.6396 10.7346 14.3896 10.7346 15.3196V18.6796C10.7346 19.6096 9.98464 20.3596 9.05464 20.3596Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0546 20.3596H15.6946C14.7646 20.3596 14.0146 19.6096 14.0146 18.6796V15.3196C14.0146 14.3896 14.7646 13.6396 15.6946 13.6396H19.0546C19.9846 13.6396 20.7346 14.3896 20.7346 15.3196V18.6796C20.7346 19.6096 19.9846 20.3596 19.0546 20.3596Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.b67fbedcfc2a8148efd0543660d1cfe3.svg";
export { ForwardRef as ReactComponent };